import React from "react";
import { connect } from "react-redux";
import { addText } from "../../../actions";
import { bindActionCreators } from "redux";
import UnifyText from "./UnifyText";
import AddTextField from "./AddTextField";
import TextField from "./TextField";
import Tabs from "../../Layout/Tabs";
import Tab from "../../Layout/Tabs/Tab";

class TextFieldList extends React.Component {
  onAddTextField = (layerId) => {
    this.props.addText({ layerId });
  };

  render() {
    const layers = this.props.layers;

    // Filter layers that allow text
    const layersWithText = layers.filter((obj) => {
      return obj.allow_text;
    });

    const firstLayerWithText = layersWithText[0],
      firstTextElement = firstLayerWithText
        ? firstLayerWithText.text_elements[0]
        : null;

    // Number of text layers
    const layersWithTextCount = layersWithText.length,
      tabsNavArray = [];

    const layerTextList = layersWithText.map((layerText, index) => {
      const maxTextFields = layerText.text_collection_max_length,
        numTextFields = layerText.text_elements.length;

      tabsNavArray.push({
        name: layerText.text_collection_name,
        layer_id: layerText.layer_id,
      });

      const textElements = layerText.text_elements.map((textElement, index) => {
        return (
          <TextField
            key={textElement.id}
            index={index}
            textElement={textElement}
            layerId={layerText.layer_id}
          />
        );
      });

      if (layersWithTextCount < 2) {
        // Single div (no tabs) if only 1 layer supports text
        return (
          <div key={layerText.id} id={index}>
            {textElements}

            {numTextFields < maxTextFields && (
              <AddTextField
                onAddTextField={() => this.onAddTextField(layerText.layer_id)}
              />
            )}
          </div>
        );
      } else {
        // Use tabs if more than 1 layer supports text
        return (
          <Tab key={layerText.id} id={index}>
            {textElements}

            {numTextFields < maxTextFields && (
              <AddTextField
                onAddTextField={() => this.onAddTextField(layerText.layer_id)}
              />
            )}
          </Tab>
        );
      }
    });

    let layerTextWrapper = (
      <div className="textfields__layer-wrapper">{layerTextList}</div>
    );

    if (layersWithTextCount > 1) {
      // Wrap in Tabs component if more than 1 layer supports text
      layerTextWrapper = (
        <Tabs tabsNavArray={tabsNavArray}>{layerTextList}</Tabs>
      );
    }

    return (
      <div className="tool tool--textfields">
        <UnifyText firstTextElement={firstTextElement} />

        <div className="tabs__wrapper">{layerTextWrapper}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    design: state.design.present,
    layers: state.design.present.layer_set,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators({ addText }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TextFieldList);
